import React from "react";
import { useQuery } from "@apollo/react-hooks";

import HeadingCore from "core/Heading";

import { GET_PHOTO_ROYALTIES_STATEMENT_MONTHS } from "./queries";

const Heading = () => {
    const { data, loading } = useQuery(GET_PHOTO_ROYALTIES_STATEMENT_MONTHS);

    if (loading) return null;

    const {
        photoRoyalties: {
            statements: { items, totalCount }
        }
    } = data;

    if (totalCount === 0) return null;

    const latestStatementMonth = items[0].month;

    return (
        <HeadingCore size="lg">
            Lifetime Summary Through {latestStatementMonth}
        </HeadingCore>
    );
};

export default Heading;
